(function initChascaCoffeeFinder() {
  const root = document.querySelector('[data-chasca-finder]');
  if (!root) return;

  const productsScript = root.querySelector('[data-finder-products]');
  let products = [];
  try {
    products = JSON.parse(productsScript?.textContent || '[]');
  } catch (e) {
    products = [];
  }

  const step1 = root.querySelector('[data-finder-step="1"]');
  const step2 = root.querySelector('[data-finder-step="2"]');
  const results = root.querySelector('[data-finder-results]');
  const grid = root.querySelector('[data-finder-grid]');
  const restart = root.querySelector('[data-finder-restart]');

  const state = { brew: null, taste: null };

  // Prefer known handles as safe defaults for matching
  const HANDLE_SCORES = {
    'peru-single-origin': { chocolate: 3, balanced: 3, fruity: 1, espresso: 2, filter: 3, french: 2, any: 3 },
    'colombia-roast': { chocolate: 2, balanced: 2, fruity: 2, espresso: 3, filter: 2, french: 2, any: 2 },
    'brazil-roast': { chocolate: 3, balanced: 2, fruity: 1, espresso: 2, filter: 2, french: 3, any: 2 },
  };

  function scoreProduct(product) {
    let score = 0;
    const handleScore = HANDLE_SCORES[product.handle] || {};
    const profile = `${product.profile || ''} ${product.note || ''} ${product.tags || ''}`.toLowerCase();

    if (state.taste && handleScore[state.taste]) score += handleScore[state.taste];
    if (state.brew && handleScore[state.brew]) score += handleScore[state.brew];

    if (state.taste === 'chocolate' && /caramel|chocolate|cocoa|nut|smooth/.test(profile)) score += 2;
    if (state.taste === 'fruity' && /citrus|fruit|berry|bright|floral/.test(profile)) score += 2;
    if (state.taste === 'balanced' && /balance|everyday|house|smooth/.test(profile)) score += 2;

    if (state.brew === 'espresso' && /espresso|moka/.test(profile)) score += 2;
    if (state.brew === 'filter' && /filter|v60|chemex|drip/.test(profile)) score += 2;
    if (state.brew === 'french' && /french|cafeti|press/.test(profile)) score += 2;

    // House coffee boost for unsure / everyday
    if (product.handle === 'peru-single-origin' && (state.brew === 'any' || state.taste === 'balanced')) {
      score += 2;
    }

    return score;
  }

  function showStep(n) {
    if (step1) {
      step1.hidden = n !== 1;
      step1.classList.toggle('is-active', n === 1);
    }
    if (step2) {
      step2.hidden = n !== 2;
      step2.classList.toggle('is-active', n === 2);
    }
    if (results) results.hidden = n !== 3;
  }

  function renderResults() {
    const ranked = [...products]
      .map((p) => ({ ...p, score: scoreProduct(p) }))
      .sort((a, b) => b.score - a.score)
      .slice(0, 3);

    if (!grid) return;
    grid.innerHTML = ranked
      .map(
        (p) => `
      <li>
        <a class="chasca-finder__card" href="${p.url}">
          <div class="chasca-finder__card-media">
            ${p.image ? `<img src="${p.image}" alt="" loading="lazy" width="800" height="1000">` : ''}
          </div>
          <h3 class="chasca-finder__card-title">${escapeHtml(p.title)}</h3>
          ${p.note ? `<p class="chasca-finder__card-meta">${escapeHtml(p.note)}</p>` : ''}
          ${p.price ? `<p class="chasca-finder__card-price">From ${escapeHtml(p.price)}</p>` : ''}
        </a>
      </li>`
      )
      .join('');

    showStep(3);
    results?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  root.querySelectorAll('[data-finder-brew]').forEach((btn) => {
    btn.addEventListener('click', () => {
      root.querySelectorAll('[data-finder-brew]').forEach((b) => b.classList.remove('is-selected'));
      btn.classList.add('is-selected');
      state.brew = btn.dataset.finderBrew;
      showStep(2);
    });
  });

  root.querySelectorAll('[data-finder-taste]').forEach((btn) => {
    btn.addEventListener('click', () => {
      root.querySelectorAll('[data-finder-taste]').forEach((b) => b.classList.remove('is-selected'));
      btn.classList.add('is-selected');
      state.taste = btn.dataset.finderTaste;
      renderResults();
    });
  });

  restart?.addEventListener('click', () => {
    state.brew = null;
    state.taste = null;
    root.querySelectorAll('.chasca-finder__option').forEach((b) => b.classList.remove('is-selected'));
    if (grid) grid.innerHTML = '';
    showStep(1);
  });
})();
